import utils from '../utils';

export default {
    formatDate: utils.formatDate,
    formatDateNormal: utils.formatDateNormal,
    formatNumber: utils.formatNumber,
    sanitize: utils.sanitize,
    encode: utils.encode,
    toPatentResultURL: utils.toPatentResultURL,
    formatText: utils.formatText
};
